module.exports = __webpack_public_path__ + "static/img/6094_phase_function_Paper_PointsHejduk_Prediction.f151c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6094_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VKU0
// module chunks = 0